.card {
    display: flex;
    flex-direction: column;
    padding: 1.25rem;
    gap: 1rem;
    border-radius: 12px;
    background-color: var(--static-background-standard);
    border: 1px solid var(--static-divider-standard);
    height: 100%;
}

.label {
    color: var(--static-text-strong);
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.productName {
    color: var(--static-text-strong);
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.productNameSmall {
    color: var(--static-text-standard);
    font-weight: 400;
    font-size: var(--fs-small);
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.value {
    font-size: var(--fs-normal);
    line-height: 24px;
    font-weight: 500;
    color: var(--static-text-strong);
}

.titleValue {
    display: flex;
    flex-direction: column;
    gap: 4px
}

.totalTitleValue {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-grow: 1;
    justify-content: center;
}

.link {
    text-decoration: none;
    cursor: pointer;
    color: var(--static-text-standard);
}

.disabled {
    pointer-events: none;
    color: gray;
}

.image {
    height: 64px;
    width: 64px;
    border-radius: 12px;
    padding: 8px;
    border: 4px solid var(--static-background-weak);
}

.totalValue {
    font-size: var(--fs-heading);
    font-weight: 500;
    line-height: 28px;
    color: var(--static-text-strong);
}

.totalSubHeading {
    font-size: var(--fs-normal);
    font-weight: 500;
    line-height: 24px;
    color: var(--static-text-standard);
}